import { SectionHeading } from "./ProductSelector";
import { PRODUCTS } from "../../data/products";
import { Check, Minus } from "lucide-react";

const ROWS = [
  { key: "lambda", label: "Współczynnik λ", unit: "W/m·K" },
  { key: "fireClass", label: "Reakcja na ogień" },
  { key: "thicknesses", label: "Dostępne grubości", unit: "mm" },
  { key: "width", label: "Szerokość", unit: "m" },
  { key: "hydro", label: "Hydrofobizowana" },
  { key: "vapor", label: "Paroprzepuszczalna" },
  { key: "acoustic", label: "Izolacja akustyczna" },
  { key: "eco", label: "Certyfikat EUCEB" },
  { key: "best", label: "Najlepsza dla" },
];

const cellValue = (key, p) => {
  switch (key) {
    case "lambda":
      return p.code;
    case "fireClass":
      return `Klasa ${p.fireClass}`;
    case "thicknesses":
      return p.variants.map((v) => v.thickness).join(" / ");
    case "width":
      return "1,20";
    case "hydro":
    case "vapor":
    case "acoustic":
    case "eco":
      return true;
    case "best":
      return p.id === "033"
        ? "Modernizacje, ograniczona przestrzeń"
        : p.id === "035"
        ? "Uniwersalne zastosowania"
        : "Standardowe ocieplenia poddaszy";
    default:
      return "-";
  }
};

export default function Comparison() {
  return (
    <section
      id="porownanie"
      data-testid="comparison-section"
      className="bg-zinc-50 py-20 lg:py-28 bg-stripes-subtle"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          overline="02 · Porównanie"
          title="Wybierz świadomie."
          subtitle="Pełne zestawienie parametrów technicznych wszystkich trzech wariantów wełny mineralnej szklanej."
        />

        <div
          className="mt-14 overflow-x-auto border-2 border-black bg-white"
          data-testid="comparison-table"
        >
          <table className="w-full min-w-[640px]">
            <thead className="bg-black text-white">
              <tr>
                <th className="text-left p-5 font-tech text-xs uppercase tracking-widest font-bold w-1/4">
                  Parametr
                </th>
                {PRODUCTS.map((p) => (
                  <th
                    key={p.id}
                    className="text-left p-5 font-tech text-xs uppercase tracking-widest font-bold border-l border-zinc-700"
                  >
                    <div className="font-display text-2xl text-white normal-case tracking-tighter">
                      {p.code}
                    </div>
                    <div className="text-zinc-400 text-[10px] mt-1">
                      {p.tagline}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {ROWS.map((row, idx) => (
                <tr
                  key={row.key}
                  className={`border-t border-zinc-200 ${
                    idx % 2 === 0 ? "bg-white" : "bg-zinc-50"
                  }`}
                >
                  <td className="p-5 font-tech text-xs uppercase tracking-widest text-zinc-500 font-semibold">
                    {row.label}
                    {row.unit && (
                      <span className="block text-[10px] text-zinc-400 normal-case mt-0.5">
                        {row.unit}
                      </span>
                    )}
                  </td>
                  {PRODUCTS.map((p) => {
                    const v = cellValue(row.key, p);
                    return (
                      <td
                        key={p.id}
                        className="p-5 border-l border-zinc-200 text-zinc-900"
                      >
                        {v === true ? (
                          <Check className="h-5 w-5 text-red-600" strokeWidth={2.5} />
                        ) : v === false ? (
                          <Minus className="h-5 w-5 text-zinc-400" />
                        ) : (
                          <span
                            className={`${
                              row.key === "lambda"
                                ? "font-display text-2xl text-red-600"
                                : "font-semibold text-sm"
                            }`}
                          >
                            {v}
                          </span>
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
